import { lsConstants } from "../constants";

const { VITE_STAGE } = import.meta.env;
const isDev = VITE_STAGE !== "api";

export const featureFlags = {
  createAssessment: true,
  // TODO: off on dev, where the end-to-end suite runs, until it covers contracts
  contractV2: VITE_STAGE !== "dev",
  workspace: true,
  newPackages: true,
  newDashboard: false,
  newPackageSubmission: false,
  newAssApp: true,
  evidence: isDev,
  riskMap: isDev,
};

export const isFeatureFlagOn = (feature: keyof typeof featureFlags) => {
  const localFlags = localStorage.getItem(lsConstants.FEATURE_FLAGS);
  const parseFlags = JSON.parse(localFlags || "{}");

  if (feature in parseFlags) return parseFlags[feature];

  return featureFlags[feature];
};
